import React from 'react';

import {Card, Heading, ListGroupItem} from '@albert-io/atomic';

import './empty-question-shell.scss';

export default function EmptyQuestionShell() {
  return (
    <Card className='empty-question-shell'>
      <ListGroupItem>
        <Heading as='h1' size='xs' className='m-x0'>
          <span>&nbsp;</span>
        </Heading>
      </ListGroupItem>
      <div className='empty-question-shell__body p-x4' />
    </Card>
  );
}
